define('app/config/strings',[],function() {
	'use strict';

	return {
		monitorModelName: 'Monitor',
		reportModelName: 'Report',
		closeUnsavedReportWarning: 'Are you sure you want to remove this tab? The report in the tab will also be closed and any unsaved changes to the report will be lost. Press ‘Yes’ to continue and close the report or ‘No’ to keep the tab open.',
		closeUnsavedMonitorWarning: 'Are you sure you want to remove this tab? The monitor in the tab will also be closed and any unsaved changes to the monitor will be lost. Press ‘Yes’ to continue and close the monitor or ‘No’ to keep the tab open.',
		areYouSure: 'Are you sure?'
	};
});

